import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import "./ResetPassword.css";
import { Link, useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "https://api.transtrackglobal.in";


const ResetPassword = () => {
  const [username, setUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate(); // ✅ added

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !newPassword) {
      toast.error("Username and password are required");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(`${API_URL}/api/resetPassword`, {
        username,
        newPassword,
      });

      toast.success(res.data.message);

      // clear form (UNCHANGED)
      setUsername("");
      setNewPassword("");

      // ✅ AUTO REDIRECT TO LOGIN AFTER SUCCESS
      setTimeout(() => {
        navigate("/");
      }, 2000); // 2 sec delay so toast is visible
    } catch (err) {
      toast.error(err.response?.data?.message || "Password reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-container">
      <form className="reset-card-3d" onSubmit={handleSubmit}>
        <h3 className="reset-title">Reset Password</h3>

        <div className="form-group-3d">
          <label>Username</label>
          <input
            type="text"
            placeholder="Enter username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className="form-group-3d">
          <label>New Password</label>
          <input
            type="password"
            placeholder="Enter new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>

        <button type="submit" className="reset-btn-3d" disabled={loading}>
          {loading ? "Updating..." : "Reset Password"}
        </button>

        {/* BACK TO LOGIN */}
        <Link to="/" className="back-login-btn">
          <i className="bi bi-arrow-left"></i> Back to Login
        </Link>
      </form>
    </div>
  );
};

export default ResetPassword;
